export interface OperatorTimeOption {
	readonly value: Date;
	readonly label: string;
}

export function localDateKey(date: Date | null): string {
	if (!date) return '';
	return [
		date.getFullYear(),
		String(date.getMonth() + 1).padStart(2, '0'),
		String(date.getDate()).padStart(2, '0'),
	].join('-');
}

export function toTimeOptions(
	startsLocal: readonly string[],
): readonly OperatorTimeOption[] {
	return startsLocal.flatMap((value) => {
		const match =
			/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(value);
		if (!match) return [];
		const [, year, month, day, hour, minute] = match;
		return [
			{
				value: new Date(
					Number(year),
					Number(month) - 1,
					Number(day),
					Number(hour),
					Number(minute),
				),
				label: `${hour}:${minute}`,
			},
		];
	});
}

export function matchingOrNextTime(
	options: readonly OperatorTimeOption[],
	current: Date | null,
): Date | null {
	if (options.length === 0) return null;
	if (!current) return options[0].value;
	const currentMinutes = current.getHours() * 60 + current.getMinutes();
	return (
		options.find((option) => {
			const optionMinutes =
				option.value.getHours() * 60 + option.value.getMinutes();
			return optionMinutes >= currentMinutes;
		})?.value ?? options[0].value
	);
}
